import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { ListingsFacade } from '../../+state/listings/listings.facade';
import { ListingsEntity } from '../../+state/listings/models/listings-entity';

@Component({
  selector: 'angular-community-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
})
export class JobsComponent implements OnInit {
  listings$: Observable<ListingsEntity[]>;

  constructor(private listingsFacade: ListingsFacade) {}

  ngOnInit(): void {
    this.listingsFacade.init();
    this.listings$ = this.listingsFacade.allListings$;
  }
}
